import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from "reactstrap";

import { dealsRepo } from "data/repositories/dealsRepo";
import { provincesRepo } from "data/repositories/provincesRepo";
import { themes } from "data/dbsSeed";

function emptyDeal() {
  return {
    id: "",
    provinceId: "trabzon",
    title: "",
    description: "",
    priceText: "",
    startDate: "2025-12-14",
    endDate: "2026-01-31",
    theme: "Nature",
    contactCta: "WhatsApp ile iletişim",
  };
}

export default function DealEdit() {
  const navigate = useNavigate();
  const params = useParams();
  const dealId = params.id;
  const isNew = dealId === "new" || !dealId;

  const [form, setForm] = useState(emptyDeal());
  const [error, setError] = useState("");

  const provinces = useMemo(() => provincesRepo.list(), []);

  useEffect(() => {
    setError("");
    if (isNew) {
      setForm(emptyDeal());
      return;
    }
    const current = dealsRepo.getById(dealId);
    if (!current) {
      setError("Fırsat bulunamadı");
      return;
    }
    setForm(current);
  }, [isNew, dealId]);

  const onSave = (e) => {
    e.preventDefault();
    setError("");

    if (!form.title || !form.provinceId) {
      setError("Başlık ve il zorunlu");
      return;
    }

    try {
      if (isNew) {
        dealsRepo.create(form);
      } else {
        dealsRepo.update(form.id, form);
      }
      navigate("/admin/content/deals");
    } catch (err) {
      setError(err?.message || "Kaydetme hatası");
    }
  };

  return (
    <>
      <div className="header bg-gradient-primary pb-6 pt-5 pt-md-7">
        <Container fluid>
          <div className="header-body">
            <Row className="align-items-center py-4">
              <Col lg="8" xs="12">
                <h6 className="h2 text-white d-inline-block mb-0">{isNew ? "Yeni fırsat" : `Fırsat düzenle`}</h6>
              </Col>
              <Col lg="4" xs="12" className="text-right">
                <Button tag={Link} to="/admin/content/deals" color="secondary" size="sm">
                  Listeye dön
                </Button>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container className="mt--6" fluid>
        <Row>
          <Col xl="8">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Detay</h3>
              </CardHeader>
              <CardBody>
                {error ? <Alert color="danger">{error}</Alert> : null}

                <Form onSubmit={onSave}>
                  <FormGroup>
                    <Label>ID</Label>
                    <Input value={form.id} onChange={(e) => setForm((p) => ({ ...p, id: e.target.value }))} disabled={!isNew} placeholder="(otomatik veya elle)" />
                  </FormGroup>

                  <FormGroup>
                    <Label>İl</Label>
                    <Input type="select" value={form.provinceId} onChange={(e) => setForm((p) => ({ ...p, provinceId: e.target.value }))}>
                      {provinces.map((p) => (
                        <option key={p.id} value={p.id}>
                          {p.name} ({p.id})
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label>Tema</Label>
                    <Input type="select" value={form.theme} onChange={(e) => setForm((p) => ({ ...p, theme: e.target.value }))}>
                      {themes.map((t) => (
                        <option key={t} value={t}>
                          {t}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>

                  <FormGroup>
                    <Label>Başlık</Label>
                    <Input value={form.title} onChange={(e) => setForm((p) => ({ ...p, title: e.target.value }))} />
                  </FormGroup>

                  <FormGroup>
                    <Label>Açıklama</Label>
                    <Input type="textarea" rows="5" value={form.description} onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))} />
                  </FormGroup>

                  <Row>
                    <Col md="6">
                      <FormGroup>
                        <Label>Başlangıç</Label>
                        <Input value={form.startDate} onChange={(e) => setForm((p) => ({ ...p, startDate: e.target.value }))} placeholder="YYYY-MM-DD" />
                      </FormGroup>
                    </Col>
                    <Col md="6">
                      <FormGroup>
                        <Label>Bitiş</Label>
                        <Input value={form.endDate} onChange={(e) => setForm((p) => ({ ...p, endDate: e.target.value }))} placeholder="YYYY-MM-DD" />
                      </FormGroup>
                    </Col>
                  </Row>

                  <FormGroup>
                    <Label>Fiyat metni</Label>
                    <Input value={form.priceText} onChange={(e) => setForm((p) => ({ ...p, priceText: e.target.value }))} placeholder="₺990 / kişi" />
                  </FormGroup>

                  <FormGroup>
                    <Label>CTA</Label>
                    <Input value={form.contactCta} onChange={(e) => setForm((p) => ({ ...p, contactCta: e.target.value }))} placeholder="WhatsApp ile iletişim" />
                  </FormGroup>

                  <Button color="primary" type="submit">
                    Kaydet
                  </Button>
                </Form>

                <div className="text-muted mt-3" style={{ fontSize: 12 }}>
                  TODO(firebase): deals koleksiyonu + partner bağlantıları.
                </div>
              </CardBody>
            </Card>
          </Col>

          <Col xl="4">
            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Notlar</h3>
              </CardHeader>
              <CardBody>
                <div className="text-muted" style={{ fontSize: 12 }}>
                  Bu sayfa mobildeki Deals List / Deal Detail ekranlarını besleyecek içerik içindir.
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
